/**
 * Utility functions for consistent date formatting across the application
 */

/**
 * Formats a date string to DD/MM/YYYY format, with optional time.
 * Handles both date-only strings (YYYY-MM-DD) and full datetime strings
 * @param {string} dateString - Date string from the API
 * @param {boolean} includeTime - Whether to include the time (HH:mm)
 * @returns {string} Formatted date (and time) in DD/MM/YYYY (HH:mm) format or 'N/A' if invalid
 */
export const formatDate = (dateString, includeTime = false) => {
  if (!dateString) return 'N/A';
  
  try {
    let date;
    
    // If it's a date-only string (YYYY-MM-DD), add time to avoid timezone issues
    if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      date = new Date(dateString + 'T00:00:00');
    } else {
      date = new Date(dateString);
    }
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return 'N/A';
    }
    
    // Format as DD/MM/YYYY
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    
    const datePart = `${day}/${month}/${year}`;

    if (includeTime) {
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${datePart} ${hours}:${minutes}`;
    }

    return datePart;
  } catch (error) {
    return 'N/A';
  }
};